interface AccessTokens {
  fulcrumToken: string;
}

let accessTokens: AccessTokens | undefined;

export const persistAuthTokens = (tokens: AccessTokens): void => {
  accessTokens = tokens;
};

export const getAuthToken = (key: keyof AccessTokens): string | undefined => accessTokens?.[key];

export const removeAuthToken = (): void => {
  accessTokens = undefined;
};
